import { Component } from 'vue-property-decorator';
import { AclMixin } from '@/components/acl/acl-mixin';
import { mixins } from 'vue-class-component';
import moment from 'moment';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class ReportMixin extends mixins(AclMixin,PlanLimitsMixin) {
  loadAdditionalData(param: any[]) {
    return new Promise(resolve => resolve(null))
  }

  form: any = {};
  mode: string = 'create'; // for flow
  edit: boolean = false;  // for all except flow
  active: boolean = false;

  defaultForm() {
    return {}
  }

  onChangeWorkspace(value: any) {
    this.loadAdditionalData([value]).then((payload) => {
      this.form = {
        ...this.defaultForm(),
        workspaceId:value,
        name:this.form.name
      };
    })
  }

  get selectOnlyPrivateWorkspaces() {
    switch (this.getAclSection()) {
      case 'campaign':
        return true;
      case 'affiliateNetwork':
      case 'flow':
      case 'landing':
      case 'offer':
      case 'trafficSource':
        return this.isMemberRoleUser;
    }
  }

  get workspacesList() {
    if(this.mode==='edit' || this.edit===true){
      return this.$store.state.user.workspaces
    }else{
      const workspaces = this.selectOnlyPrivateWorkspaces
        ? this.$store.getters.allPrivateWorkspaces
        : this.$store.state.user.workspaces
      return workspaces.filter((workspace:any)=>this.aclCanCreateOnSection({workspaceId:workspace.id}))
    }
  }

  get defaultWorkspace() {
    const selectedWorkspaceIds = this.$store.state.user.selectedWorkspaces;

    return (
        selectedWorkspaceIds.length 
        && this.workspacesList.find((workspace:any)=>selectedWorkspaceIds.includes(workspace.id))) 
      || this.workspacesList.find((workspace:any)=>workspace.name==='Master')
      || this.workspacesList[0]
  }

  load(workspaceId = this.defaultWorkspace.id) {
    this.form = {
      ...this.defaultForm(),
      workspaceId,
    };

    return this.loadAdditionalData([workspaceId]);
  }

  get updateInfo() {
    const { updated, created, updatedBy } = this.form;
    const date = moment(updated || created).format('DD MMM YYYY')

    if (updatedBy === 'Team Member') {
      return this.t('Updated by Team Member, {0}', [date])
    }

    const nameSource = updatedBy || this.t('No Name');
    const name = nameSource.length > 47 ? `${nameSource.substring(0, 45)}...` : nameSource

    return this.t('<b>Last Updated:</b> {0} <div>{1}</div>', [`&nbsp;<span class="name">${name}</span>`, date])
  }

  get isMainTab() {
    return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'].includes(this.$route.params.type)
  }

  get rotationOptions() {
    return [
      {
        key: 'random',
        value: this.t('Random Rotation'),
      },
      {
        key: 'paths',
        value: this.t('Paths Rotation'),
        planLimits: 'smartRotations',
      },
      {
        key: 'landings',
        value: this.t('Paths & Landings Rotation'),
        planLimits: 'smartRotations',
      },
      {
        key: 'landingsAndOffers',
        value: this.t('Paths & Landings & Offers Rotation'),
        planLimits: 'smartRotations',
      },
      {
        key: 'fixOnPath',
        value: this.t('Fix on Paths'),
        planLimits: 'smartRotations',
      },
      {
        key: 'fixOnLanding',
        value: this.t('Fix on Paths & Landings'),
        planLimits: 'smartRotations',
      },
      {
        key: 'fixOnOffers',
        value: this.t('Fix on Paths & Landings & Offers'),
        planLimits: 'smartRotations',
      },
    ]
  }
}
